import React from 'react';

export default function AuthScreen() {
  return (
    <div className="auth-screen">
      <div className="auth-background">
        <div className="auth-pattern"></div>
      </div>
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <img src="/purple-logo.svg" alt="Yukon" className="auth-logo-img" />
          </div>
          <div className="auth-content">
            <h2 className="auth-title">Sign in to Yukon</h2>
            <p className="auth-subtitle">Code freeze management for GitHub</p>

            <a href="/auth/login" className="btn btn-github btn-large">
              <i className="fa-brands fa-github"></i>
              <span>Continue with GitHub</span>
            </a>

            <p className="auth-note">
              <i className="fa-solid fa-lock"></i>
              Your credentials are secured through GitHub's OAuth authentication
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
